import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Blockquote.module.css';

class Blockquote extends PureComponent {
  render() {
    const { children, color, title, text } = this.props;
    return (
      <div styleName="wrapper">
        <blockquote styleName={classNames('block', color)}>
          <p styleName="title">{title}</p>
          <p styleName="copy">
            {text}
            {children}
          </p>
        </blockquote>
      </div>
    );
  }
}

Blockquote.propTypes = {
  children: PropTypes.node
};

export default Blockquote;
